import { type Observable, shareReplay } from "rxjs";

export type RecoverableRequestState = {
  state: "loading" | "success" | "empty" | "error";
  status?: number;
  retry: () => void;
};

export type RecoverableFeedSurface = "primary" | "secondary";

export function getRecoverableSuccessState(
  value: unknown
): "success" | "empty" {
  const data =
    typeof value === "object" && value !== null && "data" in value
      ? (value as { data?: unknown }).data
      : value;
  return Array.isArray(data) && data.length === 0 ? "empty" : "success";
}

export function shareRecoverableObservable<Model>(
  source: Observable<Model>
): Observable<Model> {
  return source.pipe(shareReplay({ bufferSize: 1, refCount: true }));
}
